import React                from 'react';
import PropTypes            from 'prop-types';
import { withStyles }       from '@material-ui/core/styles';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';
import Button               from '@material-ui/core/Button';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';

const styles = {
  root: {
    background: '#4593ea',
    borderRadius: 5,
    border: 0,
    color: 'white',
    height: 42,
    padding: '0 30px',
    width: '100%',
  },
  label: {
    textTransform: 'capitalize',
  },
};

function ClassesNesting(props) {
  const { classes } = props;

  return (
    <Button
      classes={{
        root: classes.root, // class name, e.g. `classes-nesting-root-x`
        label: classes.label, // class name, e.g. `classes-nesting-label-x`
      }}
    >

      <FontAwesomeIcon
        icon="envelope"
        size="lg"
        style={{ position:'relative',left:'-10px',top:'-1px' }}
      />
      <T>content.common.SignUpWithEmail</T>
    </Button>
  );
}

ClassesNesting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClassesNesting);